import {ALookupRowsContainer} from "./lookup.rows.container";

export class OrderedProcedureItem extends ALookupRowsContainer {
	orderedProcedureKey: number;
	orderKey: number;
	lateralityKey: number;
	bodyPartKey: number;
	sequenceId: number;
	studySeriesKey: number;
	rpCodeKey: number;
	spsCodeKey: number;
	procedureCodeKey: number;
	comments: string;
	seriesSequenceId: number;
	displaySortOrder: number;
	duration: number;
	studyLevelLateralityKey: number;

	protocolKey;
	protocolCommentsCbO;
	contrastIvAmountRadCbO: number;
	contrastIvUnitRadCbO: number;
	contrastIvNameRadCbO: number;
	protocoledByResourceIdCbO: number;
	protocoledDateCbO: Date;
}
